module.exports = __webpack_public_path__ + "static/media/SGP.23fff5e6.jpg";